'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var generateAction = require('@piconetworks/generate-action');
var produce = require('immer');
var effects = require('redux-saga/effects');
var endpoints = require('@piconetworks/endpoints');
var networkMiddleware = require('@piconetworks/network-middleware');
var Duck = require('extensible-duck');
var reselect = require('reselect');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var generateAction__default = /*#__PURE__*/_interopDefaultLegacy(generateAction);
var produce__default = /*#__PURE__*/_interopDefaultLegacy(produce);
var Duck__default = /*#__PURE__*/_interopDefaultLegacy(Duck);

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var getPayments$1 = generateAction__default['default']({
  baseActionCreatorName: 'getPayments',
  baseActionTypeName: 'GET_PAYMENTS'
});
var addPayment$1 = generateAction__default['default']({
  baseActionCreatorName: 'addPayment',
  baseActionTypeName: 'ADD_PAYMENT'
});
var updateDefaultPayment$1 = generateAction__default['default']({
  baseActionCreatorName: 'updateDefaultPayment',
  baseActionTypeName: 'UPDATE_DEFAULT_PAYMENT'
});
var deletePayment$1 = generateAction__default['default']({
  baseActionCreatorName: 'deletePayment',
  baseActionTypeName: 'DELETE_PAYMENT'
});
var types = [].concat(_toConsumableArray(getPayments$1.types), _toConsumableArray(addPayment$1.types), _toConsumableArray(updateDefaultPayment$1.types), _toConsumableArray(deletePayment$1.types));

var creators = function creators(duck) {
  return Object.assign({}, getPayments$1.creators(duck), addPayment$1.creators(duck), updateDefaultPayment$1.creators(duck), deletePayment$1.creators(duck));
};

var initialState = {
  methods: [],
  defaultMethod: null,
  error: null
};

var reducer = function reducer(state, _ref, duck) {
  var type = _ref.type,
      payload = _ref.payload,
      error = _ref.error;
  return produce__default['default'](state, function (draftState) {
    switch (type) {
      case duck.types.GET_PAYMENTS:
        draftState.methods = initialState.paymentMethods;
        draftState.defaultMethod = initialState.defaultMethod;
        draftState.error = initialState.error;
        break;

      case duck.types.GET_PAYMENTS_SUCCESS:
        draftState.methods = payload.payment_methods;
        draftState.defaultMethod = payload.payment_method_default;
        break;

      case duck.types.ADD_PAYMENT_SUCCESS:
        draftState.methods = payload.paymentMethods;
        break;

      case duck.types.DELETE_PAYMENT_SUCCESS:
        var deletedIdx = draftState.methods.findIndex(function (payment) {
          return (payment === null || payment === void 0 ? void 0 : payment.id) === (payload === null || payload === void 0 ? void 0 : payload.source_id);
        });

        if (deletedIdx !== -1) {
          draftState.methods.splice(deletedIdx, 1);
        }

        if ((payload === null || payload === void 0 ? void 0 : payload.source_id) === (draftState === null || draftState === void 0 ? void 0 : draftState.defaultMethod)) {
          draftState.defaultMethod = null;
        }

        break;

      case duck.types.UPDATE_DEFAULT_PAYMENT:
        draftState.defaultMethod = initialState.defaultMethod;
        draftState.error = initialState.error;
        break;

      case duck.types.UPDATE_DEFAULT_PAYMENT_SUCCESS:
        draftState.defaultMethod = payload.payment_method_default;
        break;

      case duck.types.GET_PAYMENTS_ERROR:
      case duck.types.ADD_PAYMENT_ERROR:
      case duck.types.UPDATE_DEFAULT_PAYMENT_ERROR:
      case duck.types.DELETE_PAYMENT_ERROR:
        draftState.error = error;
        break;

    }
  });
};

function* getPayments() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      types = _ref.types,
      publisherId = _ref.publisherId;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      headers: {
        publisherid: publisherId
      },
      url: endpoints.ME_PAYMENT(),
      method: 'get'
    }),
        data = _yield$call.data;

    if (data) {
      yield effects.put({
        type: types.GET_PAYMENTS_SUCCESS,
        payload: data
      });
    } else {
      throw new Error('unable to get payments');
    }
  } catch (error) {
    yield effects.put({
      type: types.GET_PAYMENTS_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'GET_PAYMENTS_ERROR'
    });
  }
}

function* addPayment(_ref) {
  var types = _ref.types,
      token = _ref.token,
      publisherId = _ref.publisherId;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: endpoints.ME_PAYMENT(),
      method: 'post',
      headers: {
        publisherid: publisherId
      },
      data: Object.assign({}, token.account_id && {
        account_id: token.account_id
      }, {
        token: token.id,
        source_type: token.type
      })
    }),
        data = _yield$call.data;

    if (data) {
      yield effects.put({
        type: types.ADD_PAYMENT_SUCCESS,
        payload: data
      });
    } else {
      throw new Error('unable to add payment');
    }
  } catch (error) {
    yield effects.put({
      type: types.ADD_PAYMENT_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'ADD_PAYMENT_ERROR'
    });
  }
}

function* updateDefaultPayment(_ref) {
  var types = _ref.types,
      payload = _ref.payload;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: endpoints.ME_PAYMENT(),
      method: 'get',
      data: payload
    }),
        data = _yield$call.data;

    if (data) {
      yield effects.put({
        type: types.UPDATE_DEFAULT_PAYMENT_SUCCESS,
        payload: data
      });
    } else {
      throw new Error('unable to update default payment');
    }
  } catch (error) {
    yield effects.put({
      type: types.UPDATE_DEFAULT_PAYMENT_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'UPDATE_DEFAULT_PAYMENT_ERROR'
    });
  }
}

function* deletePayment() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      types = _ref.types,
      publisherId = _ref.publisherId,
      payload = _ref.payload;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      headers: {
        publisherid: publisherId
      },
      url: endpoints.ME_PAYMENT(),
      method: 'delete',
      data: payload
    }),
        data = _yield$call.data;

    if (data !== null && data !== void 0 && data.source_id) {
      yield effects.put({
        type: types.DELETE_PAYMENT_SUCCESS,
        payload: payload
      });
    } else {
      throw new Error("unable to delete payment, ".concat(payload.source_id));
    }
  } catch (error) {
    yield effects.put({
      type: types.DELETE_PAYMENT_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'DELETE_PAYMENT_ERROR'
    });
  }
}

var sagas = function sagas(duck) {
  return {
    getPayments: function* getPayments$1(payload) {
      yield getPayments(Object.assign({}, payload, duck));
    },
    addPayment: function* addPayment$1(payload) {
      yield addPayment(Object.assign({}, payload, duck));
    },
    updateDefaultPayment: function* updateDefaultPayment$1(payload) {
      yield updateDefaultPayment(Object.assign({}, payload, duck));
    },
    deletePayment: function* deletePayment$1(payload) {
      yield deletePayment(Object.assign({}, payload, duck));
    }
  };
};

var takes = function takes(_ref) {
  var types = _ref.types,
      sagas = _ref.sagas;
  return [effects.takeEvery(types.GET_PAYMENTS, sagas.getPayments), effects.takeEvery(types.ADD_PAYMENT, sagas.addPayment), effects.takeEvery(types.UPDATE_DEFAULT_PAYMENT, sagas.updateDefaultPayment), effects.takeEvery(types.DELETE_PAYMENT, sagas.deletePayment)];
};

var selectors = function selectors() {
  return {
    payment: new Duck__default['default'].Selector(function () {
      return function (state) {
        return state === null || state === void 0 ? void 0 : state.paymentv2;
      };
    }),
    getPaymentMethods: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.payment, function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            methods = _ref.methods;

        return methods || [];
      });
    }),
    getDefaultPaymentMethod: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.payment, function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            defaultMethod = _ref2.defaultMethod;

        return defaultMethod;
      });
    }),
    getError: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.payment, function () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            error = _ref3.error;

        return error;
      });
    }),
    paymentMethods: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPayments, function (paymentMethods) {
        return paymentMethods;
      });
    }),
    getPaymentMethod: new Duck__default['default'].Selector(function (selectors) {
      return function (state, id) {
        return selectors.paymentMethods(state).find(function () {
          var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              sourceId = _ref4.sourceId;

          return sourceId === id;
        });
      };
    }),
    doesPaymentMethodExist: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPaymentMethod, function (paymentMethod) {
        return !!paymentMethod;
      });
    }),
    getPaymentMethodError: new Duck__default['default'].Selector(function (selectors) {
      return function (state, id) {
        return selectors.getError(state);
      };
    }),
    doesPaymentMethodErrorExist: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.getPaymentMethodError, function (paymentMethodError) {
        return !!paymentMethodError;
      });
    })
  };
};

var store = 'paymentv2';
var index = (function (_ref) {
  var createDuck = _ref.createDuck;
  return createDuck({
    store: store,
    initialState: initialState
  }).extend({
    creators: creators,
    types: types,
    reducer: reducer,
    sagas: sagas,
    takes: takes,
    selectors: selectors
  });
});

exports.creators = creators;
exports.default = index;
exports.initialState = initialState;
exports.reducer = reducer;
exports.sagas = sagas;
exports.store = store;
exports.takes = takes;
exports.types = types;
